import {useContext} from 'react'
import Search from '../../../../components/Search'
import {SafetyStockContext} from '../../context'

const SafetyStockSearchComponent = () => {
  const {onSearch} = useContext(SafetyStockContext)
  return (
    <Search
      onSearch={(searchTerm: string) => {
        onSearch && onSearch(searchTerm)
      }}
    />
  )
}

export default SafetyStockSearchComponent
